import { Legacyprofile, KeyProfileList as KeyProfileListData, Publicprofile } from '@/payload-types'
import LegacyFeaturedPostProfileCardComponent from '@/components/legacy-profile-profile-card/featuredPostProfileCard'
import FeaturedPostProfileCardComponent from '../public-profile-card/featuredPostProfileCard'
import { SortProfileListAlphabetically } from '@/lib/profileFunction'
interface IProps {
  profileListData: KeyProfileListData | null
}

export const KeyProfileList = ({ profileListData }: IProps) => {
  if (profileListData?.hasManyProfileList) {
    const sortedProdileList = SortProfileListAlphabetically(profileListData)
    return sortedProdileList?.map((item, index) => {
      if (item.relationTo === 'publicprofiles') {
        return (
          <FeaturedPostProfileCardComponent profileData={item.value as Publicprofile} key={index} />
        )
      } else {
        return (
          <LegacyFeaturedPostProfileCardComponent
            profileData={item.value as Legacyprofile}
            key={index}
          />
        )
      }
    })
  }
}

export default KeyProfileList
